import MyNotifications from '../components/MyNotifications'
import NotificationManagement from '../components/NotificationManagement'
import { usePermissions } from '../hooks/usePermissions'

export default function Notifications() {
  const { hasCapability } = usePermissions()
  // Everyone reads the alerts addressed to them. The console for what the school sends is refused to
  // anyone without notification operations, so it is shown only to them.
  const runsNotifications = hasCapability('access.notifications.operations')
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Notifications</h1>
        <p className="text-gray-600">Approvals, messages, announcements and alerts addressed to you.</p>
      </div>
      <MyNotifications />
      {runsNotifications && <NotificationManagement canLead={hasCapability('access.notifications.leadership')} />}
    </div>
  )
}
